import { Routes } from '@angular/router';

import { AuthGuard, AuthGuardNoRedirect } from './shared/utils/auth.guard';
import { HomeComponent } from './taskpane/home/home.component';
import { LoginComponent } from './taskpane/login/login.component';
import { SettingsComponent } from './taskpane/settings/settings.component';
import { TaskpaneComponent } from './taskpane/taskpane.component';
import { UploaderContainerComponent } from './taskpane/uploader/uploader-container.component';

/**
 * Defines the application's route configuration.
 *
 * - Redirects the root path ('') to 'taskpane'.
 * - The 'taskpane' route loads the `TaskpaneComponent` and contains child routes:
 *   - '' redirects to 'home'.
 *   - 'home' loads `HomeComponent` and requires authentication via `AuthGuard`.
 *   - 'uploader' loads `UploaderContainerComponent` and requires authentication via `AuthGuardNoRedirect`.
 *   - 'login' loads `LoginComponent`.
 *   - 'settings' loads `SettingsComponent`.
 *
 * @remarks
 * This configuration is used by Angular's RouterModule to set up navigation and access control.
 */
export const routes: Routes = [
  { path: '', redirectTo: 'taskpane', pathMatch: 'full' },
  {
    path: 'taskpane',
    component: TaskpaneComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'uploader', component: UploaderContainerComponent, canActivate: [AuthGuardNoRedirect] },
      { path: 'login', component: LoginComponent },
      { path: 'settings', component: SettingsComponent },
    ],
  },
];
